if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        document.addEventListener('tweProductsLoaded', this.attachTWEProduct.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        let cartResp = await fetch(`${routes.cart_url}.js`);
        let currentCart = await cartResp.json();

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        let inCart = currentCart.items.find((item) => item.variant_id == formData.get('id'));
        let formQuantity = parseInt(formData.get('quantity'));

        //let override = this.tweProduct.InStock && this.tweProduct.StockLevel == 0 && (this.tweProduct.Name.indexOf('Nectarosity') > -1 || this.tweProduct.Name.indexOf('Crimson Casks') > -1); 

        if (inCart && this.tweProduct && inCart.quantity + formQuantity >= this.tweProduct.StockLevel) {
          formData.set('quantity', this.tweProduct.StockLevel - inCart.quantity);

          if (formData.get('quantity') <= 0) {
            this.handleErrorMessage('You have reached the maximum quantity available for this product.');
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            return;
          }
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      attachTWEProduct() {
        let productTitle = this.dataset.product;
    
        if (!productTitle || productTitle.length == 0) {
          productTitle = this.closest('.product__info-container');
          
          if (!!productTitle) {
            productTitle = productTitle.querySelector('.product__title h1').textContent;
          } else if (this.closest('.sticky__add-to-cart')) {
            productTitle = this.closest('#MainContent').querySelector('.product__title h1').textContent
          } else {
            productTitle = this.closest('.cart-item').querySelector('.cart-item__name').textContent;
          }
        }
        let tweProduct = window.tweProducts.find((product) => product.Name.replace('Compass Box ', '').replaceAll(' ', '') === productTitle.replaceAll(' ', ''));


        this.tweProduct = tweProduct;
        if (!this.tweProduct) return;
        
        //let override = this.tweProduct.InStock && this.tweProduct.StockLevel == 0 && (this.tweProduct.Name.indexOf('Nectarosity') > -1 || this.tweProduct.Name.indexOf('Crimson Casks') > -1); 

        if (tweProduct) {
          this.toggleSubmitButton(this.tweProduct.StockLevel == 0, "Sold Out");
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
